import { SearchPostListController } from "@bakbak/controller";
import { Layout } from 'antd';
import * as React from "react";
import * as isEqual from "react-fast-compare";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { POST_LIST_LIMIT } from "../../../constants";
import { HeaderContextProps, withHeaderContext } from "../../../context/HeaderContext";
import { PostListView } from "./PostListView";

const { Content } = Layout;

interface Props {
  assignRefetch: (refetch: () => void) => void;
}
export class PostListC extends React.Component<RouteComponentProps<{}> & Props & HeaderContextProps> {

  shouldComponentUpdate(nextProps: HeaderContextProps) {
    const currentHeader = this.props.headerContext;
    const nextHeader = nextProps.headerContext;
    return !(
      isEqual(currentHeader.categoryFilter, nextHeader.categoryFilter)
      && isEqual(currentHeader.dateFilter, nextHeader.dateFilter)
      && isEqual(currentHeader.dateSort, nextHeader.dateSort)
      && isEqual(currentHeader.scoreSort, nextHeader.scoreSort)
      && isEqual(currentHeader.searchText, nextHeader.searchText)
    )
  }

  render() {
    const { assignRefetch } = this.props;
    const { searchText, categoryFilter, dateFilter, dateSort, scoreSort } = this.props.headerContext;
    if (dateFilter.length > 0 && ((dateSort && dateSort.length > 0) || (scoreSort && scoreSort.length > 0))) {
      return (
        <SearchPostListController
          text={searchText}
          categoryFilter={categoryFilter}
          dateFilter={dateFilter}
          dateSort={dateSort}
          scoreSort={scoreSort}
          limit={POST_LIST_LIMIT}
        >
          {(data) => {
            const { posts, hasMore, loadMorePosts, refetch } = data;
            assignRefetch(refetch);
            return (
              <Content style={{ minHeight: 400 }}>
                <PostListView
                  postList={posts}
                  hasMorePosts={hasMore}
                  loadMore={loadMorePosts}
                />
              </Content>
            )
          }}
        </SearchPostListController>
      );
    } else {
      return null;
    }

  }
}

export const PostListConnector = withRouter(withHeaderContext(PostListC));


// WEBPACK FOOTER //
// ./src/modules/post/list/PostListConnector.tsx